module.exports = __webpack_public_path__ + "static/img/1.dbe9dec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/attact/24/1.png
// module id = I+/u
// module chunks = 1